import {MDCTextField} from '@material/textfield';
$(document).on('turbolinks:load', function () {

    let body = $(document.body)
    let contactsShareModal = $('#contacts-share-modal')
    $("#language_1").val("en")
    $("#language_2").val("en")
    let firstFiveContactInputs = $(".contact-info").slice(0,5)

    // Remove this line later when the permission to share is added
    $("#allow-share-checkbox-div").hide()

    $(document).on('click', '[data-share-type="sms"], [data-share-type="email"]', function () {
        body.css('overflow', 'hidden')
        contactsShareModal.css('display', 'block')
    })

    $(".clear-line").on('click', function () {
        let contactInfo = $(this).parent().closest(".contact-info")
        contactInfo.find('input').val('')
        contactInfo.find('button[data-language="en"]').addClass('active')
        contactInfo.find('button[data-language="es"]').removeClass('active')
        contactInfo.find('span[id^="valid-msg-phone"]').attr("hidden", true);
        contactInfo.find('span[id^="error-msg-phone"]').attr("hidden", true);
    })

    $("#close-contacts-form, #x-close-button").on('click', function () {
        $('#contacts_form').trigger('reset');
        $('.contact-info').each(function() {
            let contactInfo = $(this);
            clearContactForm(contactInfo)
        });
    })

    $('.edit-contact-button').on('click', function() {
        var host = window.location.host;
        var contactId = $(this).data('contact-id');
        $('#edit-contact-id').val(contactId);
        $.ajax({
          url: '//' + host + '/contacts/' + contactId + '/edit',
          type: 'GET',
          success: function(response) {
            $('#edit-contact-name').val(response.name);
            $('#edit-contact-email').val(response.email);
            $('#edit-contact-phone').val(response.phone_number);
            $('#edit-contact-modal-id').fadeIn('slow');
          },
          error: function() {
            console.log('Error occurred while fetching chair invitation details');
          }
        });
    });

    $('#edit_contact_cancel_button').on('click', function() {
        let form = $(document).find('#edit-contact-form');
        $('#edit-contact-modal-id').fadeOut('slow');
        $("#error-messages").empty();
        form.trigger('reset');
    });

    if ($("#edit-contact-modal-id").length) {
        updateSaveButtonState();
    }
    $('#edit-contact-name, #edit-contact-email, #edit-contact-phone').on('input', function() {
        updateSaveButtonState();
        $("#error-messages").empty();
    });

    $('.language-buttons').on('click', '.v2-btn-2', function (e) {
        $(e.target).addClass('active')
        $(e.target).siblings().removeClass('active')
    });

    $('.language-buttons').on('click', '.v2-btn-2', function (e) {
        let hiddenLanguageField = $(this).parent().find('input[type="hidden"]')
        hiddenLanguageField.val($(e.target).attr('data-language'))
    });

    $('.tooltip-container').on('click',function () {
        $('.share-dialog-content .text').html('* Your Pitch is shared with your fundraising page but only those that make a donation get to watch your WiddyUP video.</br></br> * Upload both videos ASAP to give your donors the best experience!');
        $('.share-dialog-content .text').css('font-size', '14px');
        $('.share-dialog-content').removeClass('share-dialog-content-prop')
        $('.share-dialog-footer').removeClass('share-dialog-footer-prop')
        $('#share-dialog').fadeIn('slow');
    });

    const infoSymbol = document.querySelector('.info-symbol');
    if (infoSymbol) {
        infoSymbol.addEventListener('mouseover', function() {
            const tooltipContent = this.getAttribute('data-tooltip');
            const tooltip = createTooltip(tooltipContent);
            this.appendChild(tooltip);
        });

        infoSymbol.addEventListener('mouseout', function() {
            const tooltip = this.querySelector('.tooltip');
            if (tooltip) {
            tooltip.remove();
            }
        });
    }

    $('#submit-share-request').on('click', function() {
        $('#share-dialog').fadeOut('slow');
    });

    $(document).on('keyup', '.contact-info input', function (e) {
        let contactInfoDiv = $(this).closest('.contact-info')
        let phoneField = contactInfoDiv.find('input[name^=phone_]')
        let emailField = contactInfoDiv.find('input[name^=email_]')

        if (phoneField.val()) {
            emailField.attr('required', false)
        } else if (emailField.val()) {
            phoneField.attr('required', false)
        } else {
            // emailField.attr('required', true)
            // phoneField.attr('required', true)
        }
    })

    firstFiveContactInputs.addClass('show')

    $(document).on('click', '#add-contact', function () {
        let lastShownElement = $(".contact-info.show").last()
        setTimeout(function () {
            if ($(".contact-info:last").hasClass("show")) {
                let addContactButton = $('#add-contact')
                disableAddContactButton(addContactButton)
                addContactButton.hide()
            }
        }, 10)

        lastShownElement.nextAll().slice(0, 1).addClass("show")
    })

    var noticeMessage = localStorage.getItem('message');

    if (noticeMessage !== null) {
        $('.share-dialog-content .text').html(noticeMessage);
        $('.share-dialog-content').addClass('share-dialog-content-prop')
        $('.share-dialog-footer').addClass('share-dialog-footer-prop')
        $('#share-dialog').fadeIn('slow');
        if (noticeMessage.startsWith("Awesome! Your fundraising page has been shared.")) {
            for (var i = 0; i < 300; i++) {
                create(i);
            }
        }
        // display_alert(noticeMessage, "success", 5000)
        localStorage.removeItem('message');
    }

    function capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    $('#contact-error-ok').on('click', function() {
        $('.contact-error-modal').css('display', 'none');
      });

    $(document).on('keyup change', ".contact-info input:not(input[id^='phone'])", function () {
        if (validateAllItis()){
            enableButtonBasedOnVideosUploaded($("#share-button"), $("#save-button"))
        }else{
            disable_button($("#share-button"))
            disable_button($("#save-button"))
        }
    })

    let contactsListingModal = $('#contacts-listing-modal')
    $(document).on('click', '#contact-list-btn', function () {
        body.css('overflow', 'hidden')
        contactsListingModal.css('display', 'block')
    })

    var storedModal = localStorage.getItem('activeModal');
    if (storedModal !== null && storedModal == "contact listing") {
        if ($(".see_contacts_button").length) {
        $('.see_contacts_button').click();
        localStorage.removeItem('activeModal');
        }
    }

    $(window).on('click', function (event) {
        if (event.target === contactsListingModal.get(0)) {
            body.css('overflow', 'auto')
            contactsListingModal.css('display', 'none')
        }
    })

    $("input[id^='phone']").on('change keyup', function (e) {
        if (validateAllItis()){
            enableButtonBasedOnVideosUploaded($("#share-button"), $("#save-button"))
        }else{
            disable_button($("#share-button"))
            disable_button($("#save-button"))
        }
    })

    $(document).on('click', '.delete-button', function(e) {
        e.preventDefault();
        this.closest('.contact-row').classList.add('active-delete');
        openCustomDialog();
    });


    $(document).on('click', '#submit-delete-request', function(e) {
        confirmDelete();
        var errorMessageElement = $('#error-message');
        errorMessageElement.text('');
        enableImportButton()
    });

    $(document).on('click', '#cancel-delete-request', function(e) {
        closeCustomDialog();
        $('.contact-row.active-delete').removeClass('active-delete');
        enableImportButton()
    });

    $(document).on('click', '.edit-button', function() {
        var contactId = $(this).data('contact-id');

        var nameField = $('.editable[data-field="name"][data-contact-id="' + contactId + '"]');
        var emailField = $('.editable[data-field="email"][data-contact-id="' + contactId + '"]');
        var phoneField = $('.editable[data-field="phone"][data-contact-id="' + contactId + '"]');
        var errorMessageElement = $('#error-message');
        errorMessageElement.text('');
        var initialName = nameField.text();
        var initialEmail = emailField.text();
        var initialPhone = phoneField.text();

        nameField.html('<input type="text" value="' + initialName + '">');
        emailField.html('<input type="text" value="' + initialEmail + '">');
        phoneField.html('<input type="text" value="' + initialPhone + '">');

        var saveButton = $('<button class="save-button chip save-contact" data-contact-id="' + contactId + '">Save</button>');
        var editButton = $('<button class="edit-button chip edit-contact" data-contact-id="' + contactId + '">Edit</button>');
        $(this).replaceWith(saveButton);

        enableImportButton()

        saveButton.click(function(e) {
            e.preventDefault();
            var updatedName = nameField.find('input').val();
            var updatedEmail = emailField.find('input').val();
            var updatedPhone = phoneField.find('input').val();

            nameField.removeClass('add-red');
            emailField.removeClass('add-red');
            phoneField.removeClass('add-red');

            var isValidEmail = true;
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (updatedEmail.trim() !== '') {
                var isValidEmail = emailRegex.test(updatedEmail.trim());
            }

            if (updatedName.trim() !== '' && isValidEmail && (updatedEmail.trim() !== '' || updatedPhone.trim() !== '')) {
                nameField.text(updatedName);
                emailField.text(updatedEmail);
                phoneField.text(updatedPhone);

                $('input[data-contact-id="' + contactId + '"][name="contacts[][name]"]').val(updatedName);
                $('input[data-contact-id="' + contactId + '"][name="contacts[][email]"]').val(updatedEmail);
                $('input[data-contact-id="' + contactId + '"][name="contacts[][phone]"]').val(updatedPhone);

                enableImportButton()

                var editButton = $('<button class="edit-button chip edit-contact" data-contact-id="' + contactId + '">Edit</button>');
                $(this).replaceWith(editButton);
                errorMessageElement.text('');
            } else {
                nameField.find('input').addClass('red-border')
                emailField.find('input').addClass('red-border')
                phoneField.find('input').addClass('red-border')

                if (!isValidEmail) {
                    errorMessageElement.text('Please enter a valid email address.');
                } else {
                    errorMessageElement.text('Name, Phone or Email is required');
                }
                return false;
            }
        });
    });

    function create(i) {
        var width = Math.random() * 8;
        var height = width * 0.9;
        var colourIdx = Math.ceil(Math.random() * 3);
        var colour = "red";
        switch(colourIdx) {
        case 1:
            colour = "yellow";
            break;
        case 2:
            colour = "blue";
            break;
        default:
            colour = "red";
        }
        var confetti = $('<div class="confetti-'+i+' '+colour+'"></div>').css({
        "width" : width+"px",
        "height" : height+"px",
        "top" : -Math.random()*20+"%",
        "left" : Math.random()*100+"%",
        "opacity" : Math.random()+0.5,
        "transform" : "rotate("+Math.random()*360+"deg)"
        });

        $('body').append(confetti);

        drop(i);
    }

    function drop(x) {
        $('.confetti-' + x).animate({
            top: "100%"
        }, Math.random() * 2000 + 2000, function() {
            // Remove the confetti element after it falls
            $(this).remove();
        });
    }
})

function confirmDelete() {
    closeCustomDialog();
    var contactRow = $('.contact-row.active-delete');
    if (contactRow) {
        contactRow.remove();
    }
}

function openCustomDialog() {
    document.getElementById('custom-delete-dialog').style.display = 'block';
}

function closeCustomDialog() {
    document.getElementById('custom-delete-dialog').style.display = 'none';
}

function enableImportButton() {
    if ($('.editable input').length > 0) {
        $('#import-contacts-button').prop('disabled', true);
    } else {
        $('#import-contacts-button').prop('disabled', false);
    }
}

function disableAddContactButton(button) {
    button.prop('disabled', true)
    button.addClass('v2-btn-disabled')
    button.removeClass('v2-btn-yellow')
}

function enableAddContactButton(button) {
    button.prop('disabled', false)
    button.removeClass('v2-btn-disabled')
    button.addClass('v2-btn-yellow')
}

function disable_button(button) {
    button.prop('disabled', true)
    button.addClass('btn-disabled')
    button.removeClass('btn-orange')
}

function enable_button(button) {
    button.prop('disabled', false)
    button.removeClass('btn-disabled')
    button.addClass('btn-active')
}

function enableButtonBasedOnVideosUploaded(shareButton, saveButton) {
    const pitchVideoExists = $('.video-card-pitch video').length > 0;
    const widdyupVideoExists = $('.video-card-widdyup video').length > 0;
    const campaignIsRunning = $('#contacts_form').data('campaign-running');
    const guardianRestricted = $('#contacts_form').data('guardian-restricted');

    if (campaignIsRunning && !guardianRestricted) {
        if (pitchVideoExists && widdyupVideoExists) {
            enable_button(shareButton);
            return;
        }
        if (pitchVideoExists) {
            enable_button(shareButton);
        }
    }

    enable_button(saveButton);
}

function updateSaveButtonState() {
    var fullName = $('#edit-contact-name').val();
    var email = $('#edit-contact-email').val();
    var phoneNumber = $('#edit-contact-phone').val();

    // Enable the "SAVE" button if full_name is present and either email or phone_number is present
    if (fullName && (email || phoneNumber)) {
        $('#submit-edit-chair-request').prop('disabled', false);
    } else {
        $('#submit-edit-chair-request').prop('disabled', true);
    }
}

function display_alert(message, type, timeout = 3000) {
    let alert = $(`.alert-${type}`)

    alert.find('span').html(message)
    alert.css('display', 'flex')
    alert[0].classList.add('animate__animated', 'animate__bounceIn');

    setTimeout(function () {
        alert.css('display', 'none');
        alert[0].classList.remove('animate__animated', 'animate__bounceIn');
    }, timeout)

}

function validateAllItis(){
    let filledItis = getFilledInputs().flat().filter(element => typeof element !== 'string')
    return filledItis.every(iti => iti.isValidNumber() && iti.getNumber !== '')
}

function clearContactForm(contactInfo){
    contactInfo.find('input').val('')
    contactInfo.find('button[data-language="en"]').addClass('active')
    contactInfo.find('button[data-language="es"]').removeClass('active')
    contactInfo.find('span[id^="valid-msg-phone"]').attr("hidden", true);
    contactInfo.find('span[id^="error-msg-phone"]').attr("hidden", true);
    contactInfo.find('small[data-type-error^="name"]').attr("hidden", true);
    contactInfo.find('.v2-field label').removeClass('mdc-text-field--invalid');
    contactInfo.find('.v2-field label .mdc-floating-label').removeClass('mdc-floating-label--float-above');
    disable_button($("#share-button"))
    disable_button($("#save-button"))
}

function createTooltip(content) {
    const tooltip = document.createElement('div');
    tooltip.classList.add('tooltip');
    tooltip.innerHTML = content;
    return tooltip;
}
